import axiosInstance from "../api/axiosInstance";

export const getClientBatchCalendar = (batchId, month) =>
  axiosInstance.get(`/client/calendar/batch/${batchId}`, { params: { month } });

export const submitUnavailability = (data) =>
  axiosInstance.post("/client/calendar/unavailability", data);

export const getMyUnavailability = (batchId) =>
  axiosInstance.get("/client/calendar/unavailability", { params: { batchId } });
